import { render, staticRenderFns } from "./BaseAccordionItem.vue?vue&type=template&id=2036c0a2&scoped=true"
import script from "./BaseAccordionItem.vue?vue&type=script&lang=js"
export * from "./BaseAccordionItem.vue?vue&type=script&lang=js"
import style0 from "./BaseAccordionItem.vue?vue&type=style&index=0&id=2036c0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036c0a2",
  null
  
)

export default component.exports